import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { UpperFirstLetterPipe } from '../../pipes/upper-first-letter-pipe';

@Component({
  selector: 'app-audiences',
  imports: [TranslateModule, UpperFirstLetterPipe],
  templateUrl: './audiences.html',
  styleUrl: './audiences.scss',
})
export class Audiences {}
